<template>
    <b-modal
        :id="dialogId"
        ref="dropdownDialog"
        :title="dialogTitle"
        :ok-title="$t('project.settings.apply')"
        ok-variant="outline-info"
        :cancel-title="$t('general.cancel')"
        cancel-variant="outline-secondary"
        header-bg-variant="secondary"
        header-text-variant="white"
        centered
        no-fade
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        @ok.prevent="onOkClicked"
        @shown="onShown"
        >
        <label>{{ fieldLabel }}*</label>
        <b-form-select
            v-model="selectedValue"
            :options="options"
            :value-field="valueField"
            :text-field="textField"
            class="mb-3"
            @input="onInput"
            @change="onChange" />
    </b-modal>
</template>

<script>
import _ from 'lodash';

export default {
    name: 'dropdown-dialog',

    props: ['sourceData', 'sourceDataDisplayField', 'sourceDataValueField', 'dialogId', 'dialogTitle', 'fieldLabel', 'valueToPreselect', 'context'],
    
    data() {
        return {
            selectedValue: null,

            options: []
        }
    },

    mounted() {
        if (this.sourceData) {
            this.options = _.cloneDeep(this.sourceData);
        }

        if (this.valueToPreselect) {
            this.selectedValue = _.clone(this.valueToPreselect);
        }
    },

    computed: {
        textField() {
            return this.sourceDataDisplayField || 'text';
        },

        valueField() {
            return this.sourceDataValueField || 'value';
        }
    },

    watch: {
        sourceData() {
            if (this.sourceData) {
                this.options = _.cloneDeep(this.sourceData);
            }
        },

        valueToPreselect(newVal) {
            this.selectedValue = newVal;
        }
    },

    methods: {
        onInput() {

        },

        onChange() {

        },

        onOkClicked(event) {
            // prevents the modal from closing
            event.preventDefault();

            let eventName = this.dialogId + '::value-selected';
            this.$root.$emit(eventName, { selectedValue: this.selectedValue, context: this.context });
        },

        onShown() {
            this.selectedValue = null;

            if (this.valueToPreselect) {
                this.selectedValue = this.valueToPreselect;
            }
        }
    }
}
</script>

<style>
</style>
